/* eslint-disable react/no-did-update-set-state */
import { ContentZonesService, LocaleService, WindowProxy, UrlService } from '@sm360/widget-commons-core-services';
import {
    AnalyticsService,
    MEDIA_QUERIES,
    TRACKING_TAGS as TAGS,
    VehiclesService,
    ADOBE_TAGS,
    AdobeService,
    ADOBE_VARIANT_CONSTANTS,
    ShiftDigitalService,
} from '@sm360/widget-commons-general';
import { PurchaseMethodsV25, Vehicle, InventoryTypeConstants } from '@sm360/widget-commons-vehicle';
import TradeIn360Default from '@sm360/widget-trade-in-360';
import DisclaimerAPIService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js';
import { motoInsight } from 'commons-vehicle/services/ThirdPartiesJs/ThirdParties.js';
import * as actions from 'inventory-listing/actions/listingUsedActions.js';
import ListingFilters from 'inventory-listing/components/ListingFilters/ListingFilters.jsx';
import ListingHeader from 'inventory-listing/components/ListingHeader/ListingHeader.jsx';
import ListingResults from 'inventory-listing/components/ListingResults/ListingResults.jsx';
import EmptyResult from 'inventory-listing/components/ListingUsed/EmptyResults/EmptyResult.jsx';
import ListingFooter from 'inventory-listing/components/ListingUsed/ListingFooter/ListingFooter.jsx';
import 'inventory-listing/components/ListingUsed/ListingUsed.scss';
import OrderBy from 'inventory-listing/components/OrderBy/OrderBy.jsx';
import withAnalytics from 'inventory-listing/containers/withAnalytics/withAnalytics.jsx';
import ResultVehicles from 'inventory-listing/components/ResultVehicles/ResultVehicles.jsx';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';
import { DEFAULT_PAGE_SIZE } from 'inventory-listing/constants/listing.js';
import ListingPayment from 'inventory-listing/containers/ListingPaymentsFilter/ListingPaymentsFilter.js';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';
import bodyStylesList from 'inventory-listing/constants/bodyStyle.js';
import { debounce, isArray, isEmpty, isObject, isString, isNumber, snakeCase, find } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { bindActionCreators } from 'redux';

const { PurchaseMethodsConstantV25 } = PurchaseMethodsV25;
const { TradeInBarWrapper: TradeIn360BarWrapper } = TradeIn360Default.components;

class ListingUsed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterOpened: false,
            rotateIcon: false,
            isLoadingVehicles: false,
            isLoadingPrices: false,
            currentCount: 0,
            totalCount: 0,
            pagination: {},
            paymentOptionsMetadata: [],
        };

        this.formatProperties = this.formatProperties.bind(this);
        this.mobileFilterClick = this.mobileFilterClick.bind(this);
        this.onFilterClose = this.onFilterClose.bind(this);
        this.loadMoreVehicle = this.loadMoreVehicle.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.createShadowBox = this.createShadowBox.bind(this);
        this.loadVehicles = this.loadVehicles.bind(this);
        this.loadFilters = this.loadFilters.bind(this);
        this.debounceLoadVehicles = debounce(this.loadVehicles, 800);
        this.debounceLoadFilters = debounce(this.loadFilters, 400);
        this.getCleanListingH1 = this.getCleanListingH1.bind(this);
        this.getInventoryType = this.getInventoryType.bind(this);
    }

    componentDidMount() {
        DisclaimerAPIService.getGenericDisclaimers().then(this.props.actions.setGenericDisclaimers);
    }

    componentDidUpdate(prevProps) {
        // Refresh total vehicle count if the vehicleCriteria changed
        if (
            prevProps.vehicleCriteria.colanderSlug !== this.props.vehicleCriteria.colanderSlug ||
            prevProps.makePriorities !== this.props.makePriorities
        ) {
            this.loadAPIDataWithOutFilters();
            if (prevProps.vehicleCriteria.colanderSlug !== null) this.props.actions.resetVehicleCriteria();
        }

        // Refresh filter metadatas
        if (prevProps.vehicleCriteria !== this.props.vehicleCriteria) this.debounceLoadFilters();

        // Refresh vehicle list if criteria/order/paymentOptions/tradeInVehicle changed
        if (
            prevProps.vehicleCriteria !== this.props.vehicleCriteria ||
            prevProps.vehicleOrders !== this.props.vehicleOrders
        ) {
            // Vehicles position may have changed: blur all tiles while refreshing vehicles
            this.setState({ isLoadingVehicles: true }, this.debounceLoadVehicles);
        } else if (
            prevProps.paymentOptions.purchaseMethod !== this.props.paymentOptions.purchaseMethod ||
            prevProps.paymentOptions.initialCashDown !== this.props.paymentOptions.initialCashDown ||
            prevProps.paymentOptions.maximumTerm !== this.props.paymentOptions.maximumTerm ||
            prevProps.paymentOptions.preferredPaymentFrequency !==
                this.props.paymentOptions.preferredPaymentFrequency ||
            prevProps.tradeInVehicle.amount !== this.props.tradeInVehicle.amount ||
            prevProps.tradeInVehicle.lienAmount !== this.props.tradeInVehicle.lienAmount
        ) {
            // Vehicles position is identical, only the prices change: we blur the prices only while refreshing vehicles
            this.setState({ isLoadingPrices: true }, this.debounceLoadVehicles);
        }
        if (window.MOTOINSIGHT) {
            motoInsight(`${LocaleService.getLocale().toLowerCase()}-ca`);
        }
    }

    onFilterClose() {
        this.setState({
            filterOpened: false,
        });

        this.handleScroll(false);

        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const shadow = windowProxy.document.getElementById('listing-shadow');
            if (shadow) {
                windowProxy.document.getElementById('listing-shadow').remove();
            }
        }
    }

    getInventoryType(colanderSlug) {
        if (this.props.colanderGroupSlug === COLANDER_GROUPS.NEW) {
            if (colanderSlug === 'new-commercial') {
                return InventoryTypeConstants.COMMERCIAL;
            }
            return InventoryTypeConstants.NEW;
        } else if (this.props.colanderGroupSlug === COLANDER_GROUPS.COMMERCIAL) {
            return InventoryTypeConstants.COMMERCIAL;
        }
        return InventoryTypeConstants.USED;
    }

    getSelectedBodyStyle(metadatas, selectedOptions) {
        const bodyStyles = metadatas.filter(({ name }) => name === 'frameStyleId');
        if (selectedOptions.length === 1 && bodyStyles.length === 1) {
            return bodyStyles[0]?.metadatas?.filter(({ code }) => code === ~~selectedOptions[0]);
        }
        return false;
    }

    getCleanListingH1(baseTitle, listingH1, keywords) {
        const keyword = keywords.find((kw) => listingH1.includes(LocaleService.t(kw)));

        if (keyword) {
            const translatedKeyword = LocaleService.t(keyword);
            return `${baseTitle} ${listingH1.substring(listingH1.indexOf(translatedKeyword))}`;
        }
        return baseTitle;
    }

    // Fetches the vehicles from the API
    // Returns a Promise with the result of the query if resolved, or the error is rejected
    fetchVehicles(params) {
        /**
         * noFilters - To get total number of vehicles without applying filter
         * loadMore - Boolean to set if load more button clicked
         */
        const { noFilters, loadMore } = params || {};
        const props = this.formatProperties(this.props);
        const config = {
            orgId: props.organizationId,
            orgUnitId: props.organizationUnitId,
            location: props.organizationUnitLocation,
            soldDaysShown: props?.websiteSoldDaysShown || 0,
        };
        const options = {
            sortList: isEmpty(props.vehicleOrders?.vehicleSortParameter)
                ? props.defaultVehicleOrders
                : [props.vehicleOrders],
            makePriority: props.hasMakePriorityEnabled ? props.makePriorities : [],
        };
        if (loadMore) {
            /**
             * Load more button click
             */
            let currentPageNumber = 1;
            currentPageNumber =
                this.state.pagination?.pageNumber > 1 // in Case if already follow the normal way to fetch the vehicles (Without top finance bar update)
                    ? this.state.pagination?.pageNumber
                    : this.state.pagination?.pageSize / DEFAULT_PAGE_SIZE;
            options.pageNumber = currentPageNumber + 1 || 1;
            options.pageSize = DEFAULT_PAGE_SIZE;
        } else {
            /**
             * If fetch vehicle called from top finanace bar set page number to 1
             * Count total vehicles displayed and fetch the total vehicles at onces
             */
            options.pageNumber = 1;
            options.pageSize =
                this.props?.vehicles?.length > DEFAULT_PAGE_SIZE ? this.props.vehicles.length : DEFAULT_PAGE_SIZE;
        }
        const {
            preferredPaymentFrequency,
            purchaseMethod,
            initialCashDown,
            maximumTerm,
            defaultTerm,
        } = this.props.paymentOptions;

        const { amount: tradeIn, lienAmount: lien } = this.props.tradeInVehicle;
        const isMaximumTermAvailable = UrlService.getUrlParameter('maximumTerm');
        const finalTerm = defaultTerm === null || defaultTerm === '' || defaultTerm === 0 ? maximumTerm : defaultTerm;
        /**
         * PaymentOptionsData - retrieved from URL after top finance bar change
         */
        const paymentOptionsData = {
            initialCashDown,
            preferredPaymentFrequency,
            purchaseMethod,
            maximumTerm: isMaximumTermAvailable ? maximumTerm : finalTerm,
            tradeIn,
            lien,
        };
        const isNew =
            props.colanderGroupSlug === COLANDER_GROUPS.NEW ||
            (props?.colanderCategorySlug &&
                (props?.colanderCategorySlug?.toLowerCase().includes('new') ||
                    props?.colanderCategorySlug?.toLowerCase().includes('neufs')));

        return VehiclesService.loadVehicles(
            noFilters ? props.vehicleCriteria.mapToLimitedMandatoryPropertySetObject() : props.vehicleCriteria,
            config,
            isNew,
            props.locale,
            options,
            paymentOptionsData,
            this.props?.isCustomColanderSlug,
            props.listingContext?.multiDealersWebsite
        )
            .then(
                ({
                    pagination,
                    totalElements,
                    inventoryVehicles,
                    paymentOptionsMetadata,
                    tradeInTaxCreditsDetails,
                }) => {
                    // If vehicle are new: we have to fetch the configuration token from Showroom for each of them
                    if (isNew && !noFilters && inventoryVehicles) {
                        const vehiclesShowroomIds = inventoryVehicles.map((vehicle) => vehicle.showroomVehicleId);
                        return Vehicle.VehicleAPIService.findVehicleByIds(vehiclesShowroomIds).then(
                            (showroomVehicles) => {
                                const updatedVehicles = inventoryVehicles.map((vehicle) => {
                                    const showroomVehicle = find(showroomVehicles, { id: vehicle.showroomVehicleId });
                                    if (!showroomVehicle) {
                                        return vehicle;
                                    }
                                    vehicle.configurationToken = showroomVehicle.configurationToken;
                                    return vehicle;
                                });
                                return Promise.resolve({
                                    pagination,
                                    totalElements,
                                    inventoryVehicles: updatedVehicles,
                                    paymentOptionsMetadata,
                                    tradeInTaxCreditsDetails,
                                });
                            }
                        );
                    }
                    return Promise.resolve({
                        pagination,
                        totalElements,
                        inventoryVehicles,
                        paymentOptionsMetadata,
                        tradeInTaxCreditsDetails,
                    });
                }
            )
            .catch((e) => {
                return Promise.reject(e);
            });
    }

    // Load total vehicle count
    // Update Finance bar payment options from paymentOptionsMetadata
    loadAPIDataWithOutFilters() {
        this.fetchVehicles({ noFilters: true }).then(({ totalElements, paymentOptionsMetadata }) => {
            this.setState({ totalCount: totalElements, paymentOptionsMetadata });
        });
    }

    // Fetches and loads the vehicles in the store
    loadVehicles(params) {
        const { loadMore } = params || {};
        this.fetchVehicles({ loadMore })
            .then(
                ({
                    pagination,
                    totalElements,
                    inventoryVehicles,
                    paymentOptionsMetadata,
                    tradeInTaxCreditsDetails,
                }) => {
                    if (!inventoryVehicles) throw new Error('No vehicles were returned');
                    const vehicles = inventoryVehicles.map((vehicle) => {
                        return new Vehicle.VehicleModelV25(vehicle);
                    });
                    this.setState({
                        currentCount: totalElements,
                        pagination,
                        paymentOptionsMetadata,
                    });
                    ShiftDigitalService.updateListingEvent(
                        this.props.vehicleCriteria,
                        this.props.metadatas,
                        totalElements,
                        bodyStylesList,
                        this.props.colanderGroupSlug
                    );
                    this.props.tradeInActions.setTradeInTaxCreditDetails(
                        tradeInTaxCreditsDetails || { tradeInTaxCredits: 0, taxesDetail: '' }
                    );
                    if (loadMore) {
                        this.props.actions.loadMoreVehicles(vehicles);
                    } else {
                        this.props.actions.loadAndSetVehicles(vehicles);
                    }
                    this.updateAvailablePaymentOptions();
                }
            )
            .catch((e) => console.error(e))
            .finally(() => {
                this.setState({ rotateIcon: false, isLoadingVehicles: false, isLoadingPrices: false });
            });
    }

    // Fetches and loads the filter metadatas in the store
    loadFilters() {
        const colander = this.props.colanders.find((c) => c.slug === this.props.vehicleCriteria.colanderSlug);
        const config = {
            orgId: this.props.organizationId,
            orgUnitId: this.props.organizationUnitId,
            websiteId: this.props.websiteId,
            soldDaysShown: this.props.websiteSoldDaysShown,
            colanderUrl: colander ? colander.urlMapping : '',
        };
        return VehiclesService.loadFilterMetadatas(this.props.vehicleCriteria, config, this.props.locale).then(
            (result) => {
                let metadataCategories = [];
                if (result && result.data) {
                    metadataCategories = Object.entries(result.data).map(([name, value]) => {
                        let metadatas = [];
                        if (value && isArray(value)) {
                            metadatas = value.map((metadata) => {
                                // Default label if the metadata has not correct key
                                if (metadata.key === -1) metadata.label = LocaleService.t('FILTERS.OTHER');
                                return new MetaDataModel({ ...metadata, code: metadata.key });
                            });
                        }

                        if (value && isObject(value) && isNumber(value?.min) && isNumber(value?.max)) {
                            metadatas.push(new MetaDataModel({ code: 'MIN', label: value.min, url: value.min })); // MIN
                            metadatas.push(new MetaDataModel({ code: 'MAX', label: value.max, url: value.max })); // MAX
                        }
                        return {
                            name,
                            metadatas,
                        };
                    });
                }
                if (!this.firstLoad) {
                    if (this.props.hasAdobeTagging) {
                        let nameplate = '';
                        if (this.props.listingContext.make?.name && this.props.listingContext.model?.name) {
                            nameplate = `${this.props.listingContext.make?.name} ${
                                this.props.listingContext.model?.name
                            }`;
                        }
                        const queryParamFramestyle = UrlService.getUrlParameter('frameStyleTypes');
                        const selectedFramestyle = queryParamFramestyle ? queryParamFramestyle.split(',') : [];

                        const selectedBodyStyle = this.getSelectedBodyStyle(metadataCategories, selectedFramestyle);
                        const bodyStyleName = selectedBodyStyle.length === 1 && selectedBodyStyle[0]?.label;

                        AdobeService.eventTrigger(
                            ADOBE_TAGS.INVENTORY_LISTING_ON_LOAD(bodyStyleName, nameplate),
                            ADOBE_VARIANT_CONSTANTS.GLOBAL_OVERLAY
                        );
                    }
                    const vehicleModel = {
                        status: this.props.colanderGroupSlug === COLANDER_GROUPS.NEW ? 'New' : 'Used',
                    };
                    ShiftDigitalService.updateDrImpression(null, null, vehicleModel);
                    ShiftDigitalService.updateDrPageView(null, null, vehicleModel);
                    this.firstLoad = true;
                }
                this.props.actions.setMetadatas(metadataCategories);
            }
        );
    }

    // Load available payment options metadata from API
    // For Finance/lease Payment Frequencies
    // For Finance/lease terms
    updateAvailablePaymentOptions() {
        const { paymentOptionsMetadata } = this.state;
        const { paymentOptions } = this.props;
        // Valid only for Finance or lease options. No need for cash purchase
        if (
            paymentOptionsMetadata?.length > 0 &&
            [PurchaseMethodsConstantV25.FINANCE, PurchaseMethodsConstantV25.LEASE].includes(
                paymentOptions.purchaseMethod
            )
        ) {
            const currentPurchaseMethodOptions = paymentOptionsMetadata.filter(
                (paymentOption) => paymentOption.purchaseMethod === paymentOptions.purchaseMethod
            );
            // Payment Frequencies and default term returned by API for selected payment method
            const { paymentFrequencies, defaultTerm } = currentPurchaseMethodOptions[0] || {};
            // Terms returned by API for selected payment method
            const terms = currentPurchaseMethodOptions[0]?.terms;
            this.props.actions.updateAvailablePaymentOptions(paymentFrequencies, terms, defaultTerm);
        }
    }

    formatProperties(props) {
        const properties = { ...props };
        const { colanderGroupSlug } = properties;

        properties.colanderGroupSlug = isString(colanderGroupSlug)
            ? snakeCase(colanderGroupSlug)
            : this.constructor.defaultProps.colanderGroupSlug;

        return properties;
    }

    mobileFilterClick() {
        setTimeout(() => {
            this.setState(
                {
                    filterOpened: true,
                },
                () => {
                    this.handleScroll(true);
                    this.createShadowBox();
                }
            );
        }, 1);
    }

    handleScroll(enable) {
        if (WindowProxy.get()) {
            const htmlElement = document.getElementsByTagName('html')[0];
            const bodyElement = document.body;
            if (enable) {
                bodyElement.className += ' no-sroll';
                htmlElement.className += ' no-sroll';
            } else {
                bodyElement.className = bodyElement.className.replace('no-sroll', '');
                htmlElement.className = htmlElement.className.replace('no-sroll', '');
            }
        }
    }

    loadMoreVehicle(inventoryType) {
        if (this.props.hasAdobeTagging) {
            if (this.props.colanderGroupSlug === COLANDER_GROUPS.COMMERCIAL) {
                // This is used commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_OTHER_ACTIONS(InventoryTypeConstants.USED, 'load more'),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else if (
                this.props.colanderGroupSlug === COLANDER_GROUPS.NEW &&
                inventoryType === InventoryTypeConstants.COMMERCIAL
            ) {
                // This is new commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_OTHER_ACTIONS(InventoryTypeConstants.NEW, 'load more'),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else {
                // This is either new or used inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.SEARCH_RESULT_PAGE_OTHER_ACTIONS(
                        this.props.colanderGroupSlug === COLANDER_GROUPS.NEW ? 'New' : 'Used',
                        'load more'
                    ),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            }
        }
        AnalyticsService.gaTrigger(TAGS.LOAD_MORE_BTN(WindowProxy.location().pathname));
        this.setState(() => {
            return {
                rotateIcon: true,
            };
        });
        // Next page load vehicles
        this.loadVehicles({ loadMore: true });
    }

    createShadowBox() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const elemDiv = windowProxy.document.createElement('div');
            elemDiv.id = 'listing-shadow';
            windowProxy.document.body.appendChild(elemDiv);
        }
    }

    render() {
        const props = this.formatProperties(this.props);

        const btnLoading = this.state.rotateIcon
            ? 'listing-used-button-loading sr-button-1 loading-more'
            : 'listing-used-button-loading sr-button-1';

        const contentClass = this.state.filterOpened
            ? 'listing-used-inner-content clearfix filterOpen'
            : 'listing-used-inner-content clearfix';

        const { pagination, isLoadingVehicles, isLoadingPrices, totalCount, currentCount } = this.state;

        const czBackgroundImgUrl = ContentZonesService.getContentZone('widget.listing.used', 'background.img');
        this.style = {
            backgroundImage:
                czBackgroundImgUrl && czBackgroundImgUrl.getValue() ? `url(' ${czBackgroundImgUrl.getValue()}')` : '',
        };

        const { colanderList } = this.props;

        let listingUrl = '';
        let listingTitle = LocaleService.t('ALL_VEHICLES');

        if (this.props.colanderGroupSlug === COLANDER_GROUPS.DEFAULT)
            listingTitle = LocaleService.t('ALL_USED_VEHICLES');

        if (this.props.colanderGroupSlug === COLANDER_GROUPS.NEW) listingTitle = LocaleService.t('ALL_NEW_VEHICLES');

        let colanderSlug = InventoryTypeConstants.NEW;
        if (colanderList && colanderList.length > 0) {
            colanderList.forEach((colander) => {
                if (colander.slug === props.colanderGroupSlug) {
                    colander.colanders.forEach((col) => {
                        if (col.slug === this.props.vehicleCriteria.colanderSlug) {
                            listingUrl = LocaleService.t('FILTERS.URL_FILTER', {
                                slug: col.urlMapping,
                            });
                            listingTitle = col.name;
                            colanderSlug = col.slug;
                        }
                    });
                }
            });
        }

        listingTitle = this.getCleanListingH1(listingTitle, this.props.listingH1, ['FOR_SALE', 'AT']);

        const showResults = this.state.currentCount > 0 || isLoadingVehicles;

        // Pass parent props to TradeIn360 widget
        const instantEstimate = (
            <TradeIn360BarWrapper
                isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                style={{ marginTop: '60px' }}
                websiteLogo={this.props?.websiteLogo}
                websiteDomain={this.props?.websiteDomain}
                organizationUnitPhone={this.props?.organizationUnitPhone}
                websiteFacebookPageUrl={this.props?.websiteFacebookPageUrl}
                websiteInstagramClientId={this.props?.websiteInstagramClientId}
                websiteInstagramUserId={this.props?.websiteInstagramUserId}
                websiteTwitterUrl={this.props?.websiteTwitterUrl}
                websiteYoutubeUrl={this.props?.websiteYoutubeUrl}
                organizationUnitName={this.props?.organizationUnitName}
                isBarWrapper={false}
                dealerMake={this.props?.dealerMake}
            />
        );

        const inventoryType = this.getInventoryType(colanderSlug);

        const loadMoreBlock = pagination.pageNumber < pagination.numberOfPages && (
            <button className={btnLoading} onClick={() => this.loadMoreVehicle(inventoryType)}>
                <icon className="icon-refresh picto-showroom" />
                {LocaleService.t('LOAD_MORE')}
            </button>
        );

        return (
            <div className="listing-used" style={this.style}>
                <ListingHeader title={listingTitle} colanderGroupSlug={props.colanderGroupSlug} />
                <div className={contentClass}>
                    <div className="listing-used-header-refine">
                        <button onClick={this.mobileFilterClick} className="picto-showroom">
                            {LocaleService.t('BUTTONS.REFINE')}
                        </button>
                    </div>

                    <ListingFilters
                        hasNewInventory={this.props.hasNewInventory}
                        hasUsedInventory={this.props.hasUsedInventory}
                        colanders={this.props.colanders}
                        colanderList={this.props.colanderList}
                        onFilterClose={this.onFilterClose}
                        updateVehicleCriteria={this.props.actions.updateVehicleCriteria}
                        colanderGroupSlug={props.colanderGroupSlug}
                        vehicleCount={this.props.vehicles.length}
                        hasMakePriorityEnabled={this.props.hasMakePriorityEnabled}
                        listingContext={this.props.listingContext}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                        inventoryType={inventoryType}
                    />

                    <div className="listing-used-car-wrapper">
                        <div className="listing-used-car-search">
                            <ListingPayment
                                hasLease={props.colanderGroupSlug === COLANDER_GROUPS.NEW}
                                inventoryType={inventoryType}
                                hasAdobeTagging={this.props.hasAdobeTagging}
                                colanderGroupSlug={this.props.colanderGroupSlug}
                            />
                            <div className="listing-used-results-infos">
                                <ListingResults
                                    isLoading={isLoadingVehicles}
                                    listingUrl={listingUrl}
                                    currentCount={currentCount}
                                    totalCount={totalCount}
                                />
                                <MediaQuery minWidth={MEDIA_QUERIES.DESKTOP.MIN}>
                                    <OrderBy
                                        allowSortByDefault={this.props.hasMakePriorityEnabled}
                                        inventoryType={inventoryType}
                                        colanderGroupSlug={this.props.colanderGroupSlug}
                                        hasAdobeTagging={this.props.hasAdobeTagging}
                                    />
                                </MediaQuery>
                            </div>
                            {showResults ? (
                                <div>
                                    <ResultVehicles
                                        colanderGroupSlug={props.colanderGroupSlug}
                                        carfaxKey={this.props.carfaxKey}
                                        vehicleLoading={isLoadingVehicles}
                                        priceLoading={isLoadingPrices}
                                        pageNumber={this.state.pagination?.pageNumber || 1}
                                        vehicles={this.props.vehicles}
                                        vdpUrl={this.props.vdpUrl}
                                        showCarfax={this.props.showCarfax}
                                        displayCreditRate={this.props.displayCreditRate}
                                        colanderCategorySlug={this.props.colanderCategorySlug}
                                        motoInsightNewEnabled={this.props.motoInsightNewEnabled}
                                        motoInsightUsedEnabled={this.props.motoInsightUsedEnabled}
                                        roadsterNewEnabled={this.props.roadsterNewEnabled}
                                        roadsterUsedEnabled={this.props.roadsterUsedEnabled}
                                        eshopNewEnabled={this.props.eshopNewEnabled}
                                        eshopUsedEnabled={this.props.eshopUsedEnabled}
                                        shopClickDriveNewEnabled={this.props.shopClickDriveNewEnabled}
                                        shopClickDriveUsedEnabled={this.props.shopClickDriveUsedEnabled}
                                        roadsterLink={this.props.roadsterLink}
                                        dealerCode={this.props.dealerCode}
                                        dealerBAC={this.props.dealerBAC}
                                    />
                                    {!isLoadingVehicles && loadMoreBlock}
                                    {instantEstimate}
                                </div>
                            ) : (
                                <EmptyResult resetVehicleCriteria={this.props.actions.resetVehicleCriteria} />
                            )}
                        </div>
                        <ListingFooter colanderGroupSlug={props.colanderGroupSlug} />
                    </div>
                </div>
            </div>
        );
    }
}

ListingUsed.defaultProps = {
    actions: {},
    carfaxKey: '',
    colanderGroupSlug: COLANDER_GROUPS.DEFAULT,
    colanders: [],
    dealerMake: '',
    hasNewInventory: false,
    hasUsedInventory: false,
    isShowroomV2Enabled: false,
    listingH1: LocaleService.t('FIND_USED_CAR'),
    vehicles: [],
    hasAdobeTagging: false,
    displayCreditRate: false,
    colanderCategorySlug: '',
    motoInsightNewEnabled: false,
    motoInsightUsedEnabled: false,
    roadsterNewEnabled: false,
    roadsterUsedEnabled: false,
    eshopNewEnabled: false,
    eshopUsedEnabled: false,
    shopClickDriveNewEnabled: false,
    shopClickDriveUsedEnabled: false,
    roadsterLink: '',
    dealerCode: '',
    dealerBAC: '',
};

ListingUsed.propTypes = {
    actions: PropTypes.shape({
        setVehicles: PropTypes.func.isRequired,
        loadVehiclesPayments: PropTypes.func.isRequired,
        updateVehicleCriteria: PropTypes.func.isRequired,
    }).isRequired,
    carfaxKey: PropTypes.string,
    colanderGroupSlug: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    colanderCategorySlug: PropTypes.string,
    // eslint-disable-next-line react/require-default-props
    colanderList: PropTypes.arrayOf(
        PropTypes.shape({
            colanders: PropTypes.array,
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    colanders: PropTypes.arrayOf(
        PropTypes.shape({
            slug: PropTypes.string,
            name: PropTypes.string,
            displayName: PropTypes.string,
            urlMapping: PropTypes.string,
        })
    ),
    dealerMake: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    hasMakePriorityEnabled: PropTypes.bool.isRequired,
    hasNewInventory: PropTypes.bool,
    hasUsedInventory: PropTypes.bool,
    // isShowroomV2Enabled: PropTypes.bool,
    listingH1: PropTypes.string,
    vdpUrl: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    vehicleCriteria: PropTypes.instanceOf(VehicleCriteriaModel).isRequired,
    vehicleOrders: PropTypes.shape({
        vehicleSortParameter: PropTypes.string,
        direction: PropTypes.string,
    }).isRequired,
    vehicles: PropTypes.arrayOf(PropTypes.instanceOf(Vehicle.VehicleModelV25)),
    showCarfax: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
    websiteLogo: PropTypes.string.isRequired,
    websiteDomain: PropTypes.string.isRequired,
    organizationUnitPhone: PropTypes.string.isRequired,
    websiteFacebookPageUrl: PropTypes.string.isRequired,
    websiteInstagramClientId: PropTypes.string.isRequired,
    websiteInstagramUserId: PropTypes.string.isRequired,
    websiteTwitterUrl: PropTypes.string.isRequired,
    websiteYoutubeUrl: PropTypes.string.isRequired,
    organizationUnitName: PropTypes.string.isRequired,
    isCustomColanderSlug: PropTypes.bool,
    motoInsightNewEnabled: PropTypes.bool,
    motoInsightUsedEnabled: PropTypes.bool,
    roadsterNewEnabled: PropTypes.bool,
    roadsterUsedEnabled: PropTypes.bool,
    eshopNewEnabled: PropTypes.bool,
    eshopUsedEnabled: PropTypes.bool,
    shopClickDriveNewEnabled: PropTypes.bool,
    shopClickDriveUsedEnabled: PropTypes.bool,
    roadsterLink: PropTypes.string,
    dealerCode: PropTypes.string,
    dealerBAC: PropTypes.string,
};

ListingUsed.displayName = 'ListingUsed';

function mapStateToProps({ listingUsed, vehicles, tradeInVehicle }) {
    const {
        vehicleCriteria,
        makePriorities,
        vehicleOrders,
        defaultVehicleOrders,
        carfaxKey,
        colanderList,
        colanders,
        vdpUrl,
        paymentOptions,
        metadatas,
    } = listingUsed;

    return {
        tradeInVehicle,
        vehicles,
        vehicleCriteria,
        makePriorities,
        vehicleOrders,
        defaultVehicleOrders,
        carfaxKey,
        colanders,
        colanderList,
        vdpUrl,
        paymentOptions,
        metadatas,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        tradeInActions: bindActionCreators(Vehicle.TradeInVehicleActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAnalytics(ListingUsed));
